module.exports = "/images/repassamos.svg?51b3a42561d575960072ca8ed6b02b08";